import { OrderStatuses } from '@insurance/types'
import { Tag, TagProps } from 'antd'
import { useTranslation } from 'react-i18next'

type Props = {
  status?: OrderStatuses
}

const statusColors: Record<OrderStatuses, TagProps['color']> = {
  [OrderStatuses.IN_PROGRESS]: 'yellow',
  [OrderStatuses.ERROR]: 'volcano',
  [OrderStatuses.CANCELED]: 'error',
  [OrderStatuses.COMPLETED]: 'green',
  [OrderStatuses.EXPIRED]: 'orange',
  [OrderStatuses.DRAFT]: 'default',
  [OrderStatuses.CRITICAL]: 'purple',
  [OrderStatuses.PAID]: 'lime',
  [OrderStatuses.CHECKOUT]: 'geekblue',
  [OrderStatuses.REFUNDED]: 'blue',
  [OrderStatuses.PENDING_REFUND]: 'cyan',
  [OrderStatuses.PENDING]: 'magenta',
  [OrderStatuses.DATA_ENTRY]: 'cyan',
  [OrderStatuses.INSPECTION]: 'gold',
  [OrderStatuses.OFFER_READY]: 'lime',
  [OrderStatuses.APPROVED]: 'green-inverse',
  [OrderStatuses.REJECTED]: 'volcano-inverse',
  [OrderStatuses.PARTIAL_PAID]: 'yellow-inverse',
  [OrderStatuses.OVERDUE]: 'red-inverse',
  [OrderStatuses.TERMINATED]: 'magenta-inverse',
  [OrderStatuses.SUBMITTED]: 'gold-inverse',
  [OrderStatuses.REFUSED]: 'purple-inverse',
  [OrderStatuses.IN_PROCESSING]: 'cyan-inverse'
}

export const OrderStatusTag = ({ status }: Props) => {
  const { t } = useTranslation()

  if (!status) return null

  return <Tag color={statusColors[status]}>{t(status)}</Tag>
}
